import React from 'react';
import { Switch } from '@material-ui/core';

export default function SelectBoolean({
	currentValue,
	onChange,
	size
}: {
	title?: string;
	currentValue: boolean;
	onChange(checked: boolean): void;
	description?: string;
	size?: any;
}) {
	return (
		<Switch
			checked={currentValue}
			onChange={(event) => onChange(event.target.checked)}
			size={size ?? 'medium'}
			color="secondary"
		/>
	);
}
